import { useCallback, useEffect } from 'react';

import type { ModelInventoryChange } from '@app/api/WarehouseInventories';
import { useUserPrint } from '@app/hooks';
import type {
  UseInventoryWsProps,
  WsEvent,
} from '@app/pages/Warehouses/Inventory/components/InventoryCard/types';
import { createWSConnection } from '@app/utils';
import {
  invokeWSMethod,
  subscribeToWsEvent,
  unsubscribeFromWsEvent,
} from '@app/utils/createWSConnection';

export const useInventoryWs = ({
  onHistory,
  inventoryId,
}: UseInventoryWsProps) => {
  const { database, userId } = useUserPrint();

  const init = useCallback(async () => {
    await createWSConnection(
      async () => {
        await invokeWSMethod('ListenOrganization', database);
        subscribeToWsEvent('OnInventoryProductChange', (ws: WsEvent) => {
          try {
            const parsed: ModelInventoryChange = JSON.parse(ws.jsonData);
            if (
              parsed.InventoryId === inventoryId &&
              parsed.UserId === userId
            ) {
              onHistory(parsed);
            }
          } catch (err) {
            // eslint-disable-next-line no-console
            console.error('[WS] InventoryWs parse error:', err);
          }
        });
      },
      (err) => {
        // eslint-disable-next-line no-console
        console.error('[WS] InventoryWs connection error:', err);
      }
    );
  }, [database, inventoryId, userId, onHistory]);

  useEffect(() => {
    init();

    return () => unsubscribeFromWsEvent('OnInventoryProductChange');
  }, [init]);
};
